import React from 'react';
import {
  fetchDrugDetails,
  fetchDrugContents,
  fetchConditionsByTerms,
  fetchConditions,
  getFaqs,
  fetchPrescriptionCardData,
  fetchBrowsePrescriptionData,
  fetchDrugDosageDetails,
  fetchArticlesData,
  fetchPressCenterData,
  fetchPressReleaseArticleData,
  fetchMedicareData,
  fetchResourceData,
  fetchDrugClass,
  fetchDrugClassDetailData,
  fetchCauses,
  fetchSymptoms,
  fetchTrendingDrugs,
  fetchAllColletctionPages,
  fetchDrugColletctionPage,
  fetchContentfulStaticData,
  fetchDrugContentsDetails,
  fetchQuestionsByTerms
} from '../services/Api/Ssr/SsrServices';
import Loadable from 'react-loadable';

import { removedRoutes } from '../constants/route.json';
/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-undef */

const loading = () => (
  <div className="loaderCenter mainLoaderPage">
    <img
      src="/content/images/loader/loading.gif"
      alt="loader"
      className="center"
    />
  </div>
);
const DrugDetail = Loadable({
  loader: () => import('../components/DrugDetails/index'),
  loading
});
const PrescriptionLayout = Loadable({
  loader: () => import('../components/prescription-2'),
  loading
});
const PrescriptionCoupons = Loadable({
  loader: () => import('../components/PrescriptionCoupons'),
  loading
});

const ConditionDetail = Loadable({
  loader: () => import('../components/Conditions/ConditionDetail'),
  loading
});
const Condition = Loadable({
  loader: () => import('../components/Conditions'),
  loading
});
const Home = Loadable({
  loader: () => import('../components/Home-V2'),
  loading
});
const DiscountPage = Loadable({
  loader: () => import('../components/PrescriptionDiscount'),
  loading
});
const DoctorsPage = Loadable({
  loader: () => import('../components/Doctors'),
  loading
});
const PharmacistsNew = Loadable({
  loader: () => import('../components/PharmacistsNew'),
  loading
});
const BrowsePrescriptions = Loadable({
  loader: () => import('../components/BrowsePrescriptions'),
  loading
});
const FlorenceHealth = Loadable({
  loader: () => import('../components/FlorenceHealth'),
  loading
});
const HomeDeliveryNew = Loadable({
  loader: () => import('../components/HomeDeliveryNew'),
  loading
});
const FaqLayout = Loadable({
  loader: () => import('../components/Faq/FaqLayout'),
  loading
});
const DiscountPageSpecific = Loadable({
  loader: () => import('../components/PrescriptionDiscountOld'),
  loading
});
const HomeDelivery = Loadable({
  loader: () => import('../components/HomeDelivery'),
  loading
});
const BrowsePrescriptionSub = Loadable({
  loader: () =>
    import('../components/BrowsePrescriptions/BrowsePrescriptionSub'),
  loading
});
const PriceLookUp = Loadable({
  loader: () => import('../components/PriceLookUp'),
  loading
});
const PartnerLander = Loadable({
  loader: () => import('../components/Partners'),
  loading
});
const DrugDosageLayout = Loadable({
  loader: () => import('../components/DrugDosage'),
  loading
});
const HowItWorks = Loadable({
  loader: () => import('../components/HowItWorks/index.js'),
  loading
});
const NotFound = Loadable({
  loader: () => import('../components/NotFound/index.jsx'),
  loading
});
const PrivacyPolicy = Loadable({
  loader: () => import('../components/PrivacyPolicy/index.js'),
  loading
});
const WashingtonPrivacyPolicy = Loadable({
  loader: () =>
    import('../components/PrivacyPolicy/WashingtonPrivacyPolicy/index.js'),
  loading
});

const TermsAndConditions = Loadable({
  loader: () => import('../components/TermsConditions/index.js'),
  loading
});

const GLP = Loadable({
  loader: () => import('../components/GLP/index.js'),
  loading
});

const homePagePath = [
  '/',
  '/es',
  '/familywize',
  '/es/familywize',
  '/lp/1',
  '/lp/2',
  '/lp/3',
  '/lp/4',
  '/lp/5',
  '/lp/6',
  '/invite/:refCode',
  '/bloodthinners',
  '/diabetes',
  '/blood-pressure'
];
const SpanishArticles = Loadable({
  loader: () => import('../components/SpanishArticles'),
  loading
});
const PressCenter = Loadable({
  loader: () => import('../components/PressCenter'),
  loading
});
const PressReleaseArticle = Loadable({
  loader: () => import('../components/PressCenter/Articles'),
  loading
});

const Medicare = Loadable({
  loader: () => import('../components/Medicare'),
  loading
});

const Resources = Loadable({
  loader: () => import('../components/Resources'),
  loading
});

const DrugCollectionResources = Loadable({
  loader: () => import('../components/DrugCollectionResources'),
  loading
});

const drugClasses = Loadable({
  loader: () => import('../components/DrugClasses'),
  loading
});

const drugClassDetail = Loadable({
  loader: () => import('../components/DrugClasses/DrugClassDetail'),
  loading
});

const DrugCollectionDetails = Loadable({
  loader: () =>
    import('../components/DrugCollectionResources/DrugCollectionDetails'),
  loading
});

const SingleCareApps = Loadable({
  loader: () => import('../components/SinglecareApps'),
  loading
});

const Symptoms = Loadable({
  loader: () => import('../components/Conditions/Symptoms'),
  loading
});

const Causes = Loadable({
  loader: () => import('../components/Conditions/Causes'),
  loading
});

const Pharmasolutions = Loadable({
  loader: () => import('../components/Pharmasolutions'),
  loading
});
// const ConditionAddOn = Loadable({
//   loader: () => import('../components//Conditions/ConditionAddOn'),
//   loading
// });

const HomeNew = Loadable({
  loader: () => import('../components/HomeNew'),
  loading
});

const MedicareD = Loadable({
  loader: () => import('../components/MedicareD'),
  loading
});

const AccountInfo = Loadable({
  loader: () => import('../components/AccountInfo'),
  loading
});

const MainSaveDrugs = Loadable({
  loader: () => import('../components/SaveDrugs'),
  loading
});

const MemberCenter = Loadable({
  loader: () => import('../components/MemberCenter/index.jsx'),
  loading
});

const LoggedOut = Loadable({
  loader: () =>
    import('../components/HomeDeliveryNew/AuthenticateModal/LoggedOut'),
  loading
});

const ChangePassword = Loadable({
  loader: () => import('../components/ChangePassword/index.jsx'),
  loading
});

const ForgotPassword = Loadable({
  loader: () => import('../components/ForgotPassword/index.js'),
  loading
});

const DrugGuide = Loadable({
  loader: () => import('../components/DrugGuide'),
  loading
});

const TvCampaign = Loadable({
  loader: () => import('../components/TvCampaign'),
  loading
});

const ComparisonPage = Loadable({
  loader: () => import('../components/ComparisonPage'),
  loading
});

const Login = Loadable({
  loader: () => import('../components/Login/index.js'),
  loading
});

const SignUpLanding = Loadable({
  loader: () => import('../components/SignUpLanding'),
  loading
});

const UserInfoUpdate = Loadable({
  loader: () => import('../components/SignIn'),
  loading
});

const AboutUs = Loadable({
  loader: () =>
    import(/* webpackChunkName: "about-us" */ '../components/AboutUs'),
  loading
});

const RxSavings = Loadable({
  loader: () => import('../components/RxSavings'),
  loading
});

const Pharmacists = Loadable({
  loader: () => import('../components/Pharmacists'),
  loading
});

// const DiscountPageLP = Loadable({
//   loader: () => import('../components/PrescriptionDiscountLP'),
//   loading
// });

const BonusSaving = Loadable({
  loader: () => import('../components/BonusSavingFAQ/index.jsx'),
  loading
});

const Referral = Loadable({
  loader: () => import('../components/Referral'),
  loading
});

const CommunicationsPreference = Loadable({
  loader: () => import('../components/CommunicationsPreference/index.jsx'),
  loading
});

const Questions = Loadable({
  loader: () => import('../components/Questions/index.js'),
  loading
});

const routes = [
  {
    path: homePagePath,
    exact: true,
    component: Home,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchTrendingDrugs(lang)
  },
  {
    path: [],
    exact: true,
    component: Home
  },
  {
    path: ['/how-it-works', '/es/como-funciona-singlecare'],
    exact: true,
    component: HowItWorks
  },
  {
    path: '/prescription/:drugName/what-is',
    component: DrugDetail,
    fetchInitialData: (path = '', cookies = {}, url) =>
      fetchDrugDetails(path.split('/').reverse()[1], cookies, url)
  },
  {
    path: '/prescription/:drugName/dosage',
    component: DrugDosageLayout,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchDrugDosageDetails(path.split('/').reverse()[1], cookies, url, lang)
  },
  {
    path: ['/prescription/:drugName/:drugName-coupons'],
    component: PrescriptionCoupons,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchDrugContentsDetails(path.split('/').reverse()[1], cookies, url, lang)
  },
  {
    path: ['/prescription/:drugName', '/es/medicamento/:drugName'],
    component: PrescriptionLayout,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchDrugContents(path.split('/').reverse()[0], cookies, url, lang)
  },
  {
    path: '/conditions/:drugName',
    exact: true,
    component: ConditionDetail,
    fetchInitialData: (path = '', cookies = {}, url) =>
      fetchConditionsByTerms(path.split('/').reverse()[0], url)
  },
  {
    path: '/questions/:drugName',
    exact: true,
    component: ConditionDetail,
    fetchInitialData: (path = '', cookies = {}, url) =>
      fetchQuestionsByTerms(path.split('/').reverse()[0], url)
  },
  {
    path: '/conditions-treatments',
    exact: true,
    component: Condition,
    fetchInitialData: () => fetchConditions()
  },
  {
    path: [
      '/prescription-discount-card',
      '/es/tarjeta-de-descuento-para-medicamentos'
    ],
    exact: true,
    component: DiscountPage,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPrescriptionCardData(path, url, lang)
  },
  {
    path: [
      '/prescription-discount-card/:storeType',
      '/es/tarjeta-de-descuento-para-medicamentos/:storeType'
    ],
    exact: true,
    component: DiscountPageSpecific,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPrescriptionCardData(path, url, lang)
  },
  {
    path: ['/doctors'],
    exact: true,
    component: DoctorsPage,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPrescriptionCardData(path, url, lang)
  },
  {
    path: ['/pharmacists'],
    exact: true,
    component: PharmacistsNew,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPrescriptionCardData(path, url, lang)
  },
  {
    path: ['/browse-prescriptions', '/es/buscar-medicamentos'],
    exact: true,
    component: BrowsePrescriptions,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchBrowsePrescriptionData(path, url, lang)
  },
  {
    path: [
      '/browse-prescriptions/:searchTerm',
      '/es/buscar-medicamentos/:searchTerm',
      '/browse-prescriptions/:searchTerm/:extraTerm',
      '/es/buscar-medicamentos/:searchTerm/:extraTerm'
    ],
    exact: true,
    component: BrowsePrescriptionSub,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchBrowsePrescriptionData(path, url, lang)
  },
  {
    path: '/lp/florence-health',
    exact: true,
    component: FlorenceHealth
  },
  {
    path: ['/prescription-delivery', '/es/medicamentos-a-domicilio'],
    exact: true,
    component: HomeDeliveryNew
  },
  {
    path: ['/partners', '/es/socios'],
    exact: true,
    component: PartnerLander
  },
  {
    path: ['/help', '/es/ayuda'],
    component: FaqLayout,
    fetchInitialData: (path = '', cookies = {}, url, lang) => getFaqs(lang)
  },
  {
    path: '/homedelivery',
    exact: true,
    component: HomeDelivery
  },
  {
    path: '/drug-price-look-up-tool',
    exact: true,
    component: PriceLookUp
  },
  {
    path: [...removedRoutes],
    exact: true,
    component: NotFound
  },
  {
    path: '/es/recursos/:slug',
    component: SpanishArticles,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchArticlesData(path.split('/').reverse()[0], cookies, url, lang)
  },
  {
    path: '/press',
    exact: true,
    component: PressCenter,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPressCenterData(path, cookies, url, lang)
  },
  {
    path: '/press/:slug',
    exact: true,
    component: PressReleaseArticle,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchPressReleaseArticleData(
        path.split('/').reverse()[0],
        cookies,
        url,
        lang
      )
  },
  {
    path: ['/medicare', '/es/medicare'],
    exact: true,
    component: Medicare,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchMedicareData(path.split('/').reverse()[0], cookies, url, lang)
  },
  {
    path: ['/recursos', '/es/recursos'],
    exact: true,
    component: Resources,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchResourceData('Recursos', path, cookies, url, lang)
  },
  {
    path: ['/drug-classes'],
    exact: true,
    component: drugClasses,
    fetchInitialData: () => fetchDrugClass()
  },
  {
    path: ['/drug-classes/:slug'],
    exact: true,
    component: drugClassDetail,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchDrugClassDetailData(path.split('/').reverse()[0], cookies, url, lang)
  },
  {
    path: ['/resources'],
    exact: true,
    component: DrugCollectionResources,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchAllColletctionPages(path, cookies, url, lang)
  },
  {
    path: ['/resources/:slug'],
    exact: true,
    component: DrugCollectionDetails,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchDrugColletctionPage(path.split('/').reverse()[0], cookies, url, lang)
  },
  {
    path: ['/conditions-symptoms'],
    exact: true,
    component: Symptoms,
    fetchInitialData: () => fetchSymptoms()
  },
  {
    path: ['/conditions-causes'],
    exact: true,
    component: Causes,
    fetchInitialData: () => fetchCauses()
  },
  {
    path: ['/pharmasolutions'],
    exact: true,
    component: Pharmasolutions
  },
  {
    path: '/app',
    exact: true,
    component: SingleCareApps
  },
  {
    path: ['/not-found'],
    exact: true,
    component: NotFound
  },
  {
    path: ['/home-new', '/es/home-new'],
    exact: true,
    component: HomeNew
  },
  {
    path: ['/medicareD'],
    exact: true,
    component: MedicareD
  },
  {
    path: ['/privacy-policy', '/es/politicas-de-privacidad-singlecare'],
    exact: true,
    component: PrivacyPolicy,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchContentfulStaticData('privacy-policy', url, lang)
  },
  {
    path: [
      '/washington-consumer-health-privacy-policy',
      '/es/politica-de-privacidad-de-salud-del-consumidor-de-washington'
    ],
    exact: true,
    component: WashingtonPrivacyPolicy,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchContentfulStaticData('washington-privacy-policy', url, lang)
  },
  {
    path: ['/terms-and-conditions', '/es/terminos-y-condiciones'],
    exact: true,
    component: TermsAndConditions,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchContentfulStaticData('terms-and-conditions', url, lang)
  },
  {
    path: ['/member-center', '/es/centro-de-atencion-para-miembros'],
    exact: true,
    component: MemberCenter
  },
  {
    path: ['/account-setting', '/es/configuracion-de-cuenta-singlecare'],
    exact: true,
    component: AccountInfo
  },
  {
    path: ['/save-drugs'],
    exact: true,
    component: MainSaveDrugs
  },
  {
    path: ['/refer-friends'],
    exact: true,
    component: Referral
  },
  {
    path: ['/loggedOut', '/es/loggedOut'],
    exact: true,
    component: LoggedOut
  },
  {
    path: ['/change-password', '/es/cambiar-contrasena'],
    exact: true,
    component: ChangePassword
  },
  {
    path: ['/forgot-password', '/es/restablecer-contrasena'],
    exact: true,
    component: ForgotPassword
  },
  {
    path: ['/cold-and-flu'],
    exact: true,
    component: DrugGuide
  },
  {
    path: ['/tvcampaign'],
    exact: true,
    component: TvCampaign
  },
  {
    path: ['/comp'],
    exact: true,
    component: ComparisonPage
  },
  {
    path: ['/Login', '/login', '/es/iniciar-sesion'],
    exact: true,
    component: Login
  },
  {
    path: ['/signup', '/es/registrarse'],
    exact: true,
    component: SignUpLanding
  },
  {
    path: ['/update-user'],
    exact: true,
    component: UserInfoUpdate
  },
  {
    path: ['/about-us', '/es/sobre-nosotros'],
    exact: true,
    component: AboutUs
  },
  {
    path: ['/rxsavings'],
    exact: true,
    component: RxSavings
  },
  {
    path: ['/pharmacists'],
    exact: true,
    component: Pharmacists
  },
  {
    path: ['/GLP1'],
    exact: true,
    component: GLP
  },
  // {
  //   path: [
  //     '/lp/prescription-discount-card',
  //     '/lp/prescription-discount-card/:storeType'
  //   ],
  //   exact: true,
  //   component: DiscountPageLP
  // },
  {
    path: ['/bonus-saving', '/es/bonificaciones-de-ahorro'],
    exact: true,
    component: BonusSaving
  },
  {
    path: ['/communications-preferences'],
    exact: true,
    component: CommunicationsPreference
  },
  {
    path: ['/questions'],
    exact: true,
    component: Questions,
    fetchInitialData: (path = '', cookies = {}, url, lang) =>
      fetchResourceData('Questions directory page', path, cookies, url, lang)
  }
];

export default routes;
